module.exports = __webpack_public_path__ + "static/img/emails_caixa_postal.e617a4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loja/emails_caixa_postal.png
// module id = 833
// module chunks = 0